module.exports = __webpack_public_path__ + "img/undo.27ff76a8.svg";